import { render, staticRenderFns } from "./ApplicationsAssignedList.vue?vue&type=template&id=5c5cb642&"
import script from "./ApplicationsAssignedList.vue?vue&type=script&lang=js&"
export * from "./ApplicationsAssignedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports